import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b6c0ca7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mydiv",
  class: "w-80 h-100",
  style: {"margin-left":"10%","margin-right":"10%"}
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = { style: {"height":"50px"} }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div style=\"width:calc(100% - 16px);\" data-v-3b6c0ca7><table id=\"tblSystemCode\" data-v-3b6c0ca7><tr data-v-3b6c0ca7><th style=\"width:25%;\" data-v-3b6c0ca7>Station Code</th><th style=\"width:25%;\" data-v-3b6c0ca7>Data ID</th><th style=\"width:30%;\" data-v-3b6c0ca7>FTP User ID</th><th style=\"width:10%;\" data-v-3b6c0ca7></th><th style=\"width:10%;\" data-v-3b6c0ca7></th></tr></table></div>", 1)
const _hoisted_5 = {
  key: 1,
  style: {"width":"calc(100% - 16px)","height":"calc(99% - 170px)"}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { style: {"text-align":"center"} }, "No data", -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  id: "tblSystembodydiv",
  style: {"overflow":"auto","height":"calc(99% - 170px)"}
}
const _hoisted_9 = {
  id: "tblSystemCode",
  class: "w-100"
}
const _hoisted_10 = {
  id: "tblTbody",
  class: "w-100"
}
const _hoisted_11 = { style: {"width":"25%"} }
const _hoisted_12 = { style: {"width":"25%"} }
const _hoisted_13 = { style: {"width":"30%"} }
const _hoisted_14 = { style: {"text-align":"center","width":"10%"} }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { style: {"text-align":"center","width":"10%"} }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  class: "modal fade",
  id: "showModal",
  tabindex: "-1",
  "aria-labelledby": "showModalLabel",
  "aria-hidden": "true",
  style: {"width":"30%","margin-left":"35%"}
}
const _hoisted_19 = {
  class: "modal-dialog modal-dialog-scrollable modal-lg",
  style: {"height":"auto"}
}
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "showModalLabel"
  }, " Delete SCAN-PC Batch Control "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1 /* HOISTED */))
const _hoisted_22 = {
  class: "modal-body",
  id: "modal-body"
}
const _hoisted_23 = { style: {"height":"auto"} }
const _hoisted_24 = { class: "row-div" }
const _hoisted_25 = { class: "adjusting-position fs-6" }
const _hoisted_26 = { class: "modal-footer" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "modelCancel",
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}, " Cancel ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading == true)
      ? (_openBlock(), _createBlock($setup["Loading"], {
          key: 0,
          isLoading: $setup.isLoading
        }, null, 8 /* PROPS */, ["isLoading"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.title }, null, 8 /* PROPS */, ["menuTile"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "newSystem",
        style: {"cursor":"pointer"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.addStationCodeForSystem()))
      }, "Add new SCAN-PC Batch Control")
    ]),
    _hoisted_4,
    ($setup.stationCodeInfo.length == 0 && $setup.getData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stationCodeInfo, (info, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(info.stationCode.stationCode), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(info.dataId), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(info.ftpUserID), 1 /* TEXT */),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("button", {
                      class: "btn btn-primary button-design-scanSystem",
                      onClick: ($event: any) => (
                  $setup.editStationCodeForSystem(
                    info.id,
                    info.stationCode.stationCode,
                    info.dataId,
                    info.ftpUserID
                  )
                )
                    }, " Edit ", 8 /* PROPS */, _hoisted_15)
                  ]),
                  _createElementVNode("td", _hoisted_16, [
                    _createElementVNode("a", {
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#showModal",
                      class: "btn btn-primary button-design-scanSystem",
                      onClick: ($event: any) => ($setup.deleteStationCodeForSystem(info.id))
                    }, " Delete ", 8 /* PROPS */, _hoisted_17)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString($setup.i18n.t("cnf009")), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", null, [
              _hoisted_27,
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary button-design",
                style: {"width":"75px"},
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.deleteRow($setup.modalStationSystemCode))),
                "data-bs-dismiss": "modal"
              }, " OK ")
            ])
          ])
        ])
      ])
    ])
  ]))
}